import { MenuItem } from "@headlessui/react";
import clsx from "clsx";

import type { ActionBlock } from "~/types/actionBlockTypes.ts";

export type ProjectCardMenuItemData = {
	block: ActionBlock;
	label: string;
	onClick: () => void;
};

// A phone has no hover, so a tooltip cannot show why an item is refused. A refused item shows its
// reason as a second line below its text, where a tap or a glance reads it.
export function ProjectCardMenuItem({ block, label, onClick }: ProjectCardMenuItemData) {
	return (
		<MenuItem disabled={!block.allowed}>
			<button type="button"
					className={clsx(
						"block w-full px-3 py-2 text-left text-sm data-[focus]:bg-gray-50",
						block.allowed ? "text-gray-900" : "cursor-not-allowed text-gray-400",
					)}
					onClick={block.allowed ? onClick : undefined}>
				{label}
				{!block.allowed && block.reason && (
					<span className="mt-0.5 block text-xs font-normal text-gray-500">{block.reason}</span>
				)}
			</button>
		</MenuItem>
	);
}
